import { Node_Type } from 'ricos-schema';

var Anchorable_Blocks_Types = /* @__PURE__ */ ((Anchorable_Blocks_Types2) => {
  Anchorable_Blocks_Types2["ATOMIC"] = "atomic";
  Anchorable_Blocks_Types2["UNSTYLED"] = "unstyled";
  Anchorable_Blocks_Types2["HEADER"] = "header";
  Anchorable_Blocks_Types2["HEADER_ONE"] = "header-one";
  Anchorable_Blocks_Types2["HEADER_TWO"] = "header-two";
  Anchorable_Blocks_Types2["HEADER_THREE"] = "header-three";
  Anchorable_Blocks_Types2["HEADER_FOUR"] = "header-four";
  Anchorable_Blocks_Types2["HEADER_FIVE"] = "header-five";
  Anchorable_Blocks_Types2["HEADER_SIX"] = "header-six";
  Anchorable_Blocks_Types2["BLOCKQUOTE"] = "blockquote";
  Anchorable_Blocks_Types2["CODE_BLOCK"] = "code-block";
  Anchorable_Blocks_Types2["IMAGE"] = "wix-draft-plugin-image";
  Anchorable_Blocks_Types2["GALLERY"] = "wix-draft-plugin-gallery";
  Anchorable_Blocks_Types2["GIF"] = "wix-draft-plugin-giphy";
  Anchorable_Blocks_Types2["VIDEO"] = "wix-draft-plugin-video";
  Anchorable_Blocks_Types2["MAP"] = "wix-draft-plugin-map";
  Anchorable_Blocks_Types2["BUTTON"] = "buttons";
  Anchorable_Blocks_Types2["FILE"] = "wix-draft-plugin-file-upload";
  return Anchorable_Blocks_Types2;
})(Anchorable_Blocks_Types || {});
const isAnchorableAtomicPluginNode = (node) => {
  const { type } = node;
  return type === Node_Type.IMAGE || type === Node_Type.GALLERY || type === Node_Type.VIDEO || type === Node_Type.MAP || type === Node_Type.BUTTON || // type === ACTION_BUTTON_TYPE ||
  type === Node_Type.GIF || type === Node_Type.FILE;
};
const isAnchorableTextNode = (node) => {
  const { type } = node;
  return type === Node_Type.PARAGRAPH || type === Node_Type.BLOCKQUOTE || type === Node_Type.CODE_BLOCK || // type === Node_Type.ORDERED_LIST ||
  // type === Node_Type.BULLETED_LIST ||
  type === Node_Type.HEADING;
};
const isThumbnailNode = (node) => {
  const { type } = node;
  return type === Node_Type.IMAGE || type === Node_Type.GALLERY || type === Node_Type.VIDEO || type === Node_Type.GIF;
};
const textNodesMapper = {
  [Node_Type.PARAGRAPH]: "unstyled" /* UNSTYLED */,
  [Node_Type.BLOCKQUOTE]: "blockquote" /* BLOCKQUOTE */,
  [Node_Type.CODE_BLOCK]: "code-block" /* CODE_BLOCK */,
  [Node_Type.HEADING]: "header" /* HEADER */
};
const headersMapper = {
  1: "header-one" /* HEADER_ONE */,
  2: "header-two" /* HEADER_TWO */,
  3: "header-three" /* HEADER_THREE */,
  4: "header-four" /* HEADER_FOUR */,
  5: "header-five" /* HEADER_FIVE */,
  6: "header-six" /* HEADER_SIX */
};
const atomicNodesMapper = {
  [Node_Type.IMAGE]: "wix-draft-plugin-image" /* IMAGE */,
  [Node_Type.GALLERY]: "wix-draft-plugin-gallery" /* GALLERY */,
  [Node_Type.VIDEO]: "wix-draft-plugin-video" /* VIDEO */,
  [Node_Type.MAP]: "wix-draft-plugin-map" /* MAP */,
  [Node_Type.BUTTON]: "buttons" /* BUTTON */,
  [Node_Type.GIF]: "wix-draft-plugin-giphy" /* GIF */,
  [Node_Type.FILE]: "wix-draft-plugin-file-upload" /* FILE */
};

export { Anchorable_Blocks_Types, atomicNodesMapper, headersMapper, isAnchorableAtomicPluginNode, isAnchorableTextNode, isThumbnailNode, textNodesMapper };
//# sourceMappingURL=helpers.js.map
